import React from "react";
import { FormProvider } from "../components/context/Form/FormContext";
import ConsultCpfForm from "../components/Consult/ConsultCpfForm";
import Sidebar from "../components/Sidebar/Sidebar";

export default function ConsultCpfPage() {
    return (
        <div
            className="d-flex"
            style={{ minHeight: "100vh", backgroundColor: "#000" }}
        >
            <Sidebar />

            <div
                className="flex-grow-1 p-4"
                style={{
                    backgroundColor: "#ffffff",
                    borderTopLeftRadius: "40px",
                    borderBottomLeftRadius: "40px",
                    padding: "32px",
                    boxShadow: "0 0 12px rgba(0,0,0,0.05)",
                }}
            >
                <h1
                    style={{
                        color: "#78E01D",
                        fontWeight: "600",
                        fontSize: "36px",
                        marginBottom: "24px",
                    }}
                >
                    Solicitar pesquisa — CPF
                </h1>

                <p style={{ fontSize: "16px", marginBottom: "24px", color: "#555" }}>
                    Carregue um documento (PDF) e selecione o produto desejado. Em seguida,
                    clique em <strong>“Enviar”</strong>. O sistema extrai o{" "}
                    <strong>CPF</strong> e os <strong>dados dos sócios</strong> do
                    documento, verifica a situação cadastral e, se estiver regular,
                    exibe os campos para validação individual dos signatários.
                </p>

                <div className="App" style={{ marginTop: "38px" }}>
                    <FormProvider>
                        <div>
                            <ConsultCpfForm />
                        </div>
                    </FormProvider>
                </div>
            </div>
        </div>
    );
}